import { ToolbarFeature } from '../types';

/**
 * MuiTipTap Component Constants
 * Default values for the editor component
 */
export const MUI_TIPTAP_CONSTANTS = {
  DEFAULT_PLACEHOLDER: '',
  DEFAULT_TITLE: '',
  DEFAULT_ACTION_TEXT: '',
  DEFAULT_SHOW_TOOLBAR: true,
  DEFAULT_TOOLBAR_FEATURES: Object.values(ToolbarFeature) as ToolbarFeature[],
} as const;
